import { render, staticRenderFns } from "./NewMember.vue?vue&type=template&id=a3766f40&scoped=true"
import script from "./NewMember.vue?vue&type=script&lang=js"
export * from "./NewMember.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a3766f40",
  null
  
)

export default component.exports